/**
 * The internal dependencies.
 */
import {
	SET_DECKS,
} from './mutations';

/**
 * The actions.
 *
 * @type {Object}
 */
export default {
	setDecks({ commit }, payload) {
		commit(SET_DECKS, payload);
	},
}


// WEBPACK FOOTER //
// ./src/store/decks/actions.js